// extracted by mini-css-extract-plugin
export default {"longWord":"ListingLink_longWord__8NFEU"};